import ReactPaginate from "react-paginate";

const Pagination = ({onChange , pageCount , currentPage = 1}) => {
    console.log("currentPage" , currentPage);
    const handlePageClick = (value) => {
        onChange(value.selected + 1)
    }

    return (
        <div className={"card"}>
            <div className="card-body">
                <nav className={'d-flex justify-content-center'} aria-label="Page navigation example">
                    <ReactPaginate
                        containerClassName={"mx-auto"}
                        className={"pagination"}
                        pageClassName={"page-item"}
                        nextClassName={"page-item"}
                        previousClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        nextLinkClassName={"page-link"}
                        previousLinkClassName={"page-link"}
                        activeClassName={"active"}
                        breakLabel=" ... "
                        nextLabel="بعدی >"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={3}
                        forcePage={currentPage - 1}
                        pageCount={pageCount}
                        previousLabel="< قبلی"
                        renderOnZeroPageCount={null}
                    />
                </nav>
            </div>
        </div>

);
}

export default Pagination;